import { jt, t } from 'ttag'

const FinancialAid = ({ aid }) => {
  const toCurrency = inp => {
    if (!inp) {
      return 'n/a'
    }

    return inp
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      .slice(0, -3)
  }
  const toNumber = inp => {
    if (!inp) {
      return 'n/a'
    }

    return inp.toLocaleString()
  }
  const finAidYear = '2019'

  return (
    <div className="section financial-aide-section sections">
      <p className="instructions">{t`Below is the average financial aid information for those who were entering postsecondary education for the first time in ${finAidYear}.`}</p>
      <table className="tbl aide-table">
        <thead>
          <tr>
            <th>{t`Grant`}</th>
            <th>{t`Num Students`}</th>
            <th>{t`Pct Students`}</th>
            <th>{t`Avg Amount`}</th>
            <th>{t`Total`}</th>
          </tr>
        </thead>
        <tbody>
          <tr className="even">
            <td>{t`Federal Grant`}</td>
            <td className="any-num">{toNumber(aid.numberFirstTimeFederalGrant)}</td>
            <td className="any-pct">{aid.percentFirstTimeFederalGrant}%</td>
            <td className="any-avg">{toCurrency(aid.averageFirstTimeFederalGrant)}</td>
            <td className="any-tot">{toCurrency(aid.totalFirstTimeFederalGrant)}</td>
          </tr>
          <tr className="odd">
            <td>{t`State/Local Grant`}</td>
            <td className="any-num">
              {toNumber(aid.numFullTimeFirstTimeStateLocalGrants)}
            </td>
            <td className="any-pct">{aid.percentFullTimeFirstTimeStateLocalGrant}%</td>
            <td className="any-avg">
              {toCurrency(aid.averageFullTimeFirstTimeStateLocalGrant)}
            </td>
            <td className="any-tot">
              {toCurrency(aid.totalFullTimeFirstTimeStateLocalGrants)}
            </td>
          </tr>
          <tr className="even">
            <td>{t`Institution Grant `}</td>
            <td className="any-num">
              {toNumber(aid.numFullTimeFirstTimeInstitutionalGrants)}
            </td>
            <td className="any-pct">
              {aid.percentFullTimeFirstTimeInstitutionalGrants}%
            </td>
            <td className="any-avg">
              {toCurrency(aid.averageFullTimeFirstTimeInstitutionalGrant)}
            </td>
            <td className="any-tot">
              {toCurrency(aid.totalFullTimeFirstTimeInstitutionalGrants)}
            </td>
          </tr>
          <tr className="odd">
            <td>{t`Loan Aid `}</td>
            <td className="any-num">{toNumber(aid.numFirstTimeUndergraduateLoans)}</td>
            <td className="any-pct">{aid.percentFirstTimeUndergraduateLoans}%</td>
            <td className="any-avg">
              {toCurrency(aid.averageFirstTimeUndergraduateLoan)}
            </td>
            <td className="any-tot">
              {toCurrency(aid.totalFirstTimeUndergraduateLoans)}
            </td>
          </tr>
          <tr className="even totalrow">
            <td>{t`Total Aid`}</td>
            <td className="any-num">
              {toNumber(aid.numOfficialFinancialAidReceivingFullTimeFirstTime)}
            </td>
            <td className="any-pct">{aid.percentFinancialAidFullTimeFirstTimeAwards}%</td>
            <td className="any-avg">
              {toCurrency(aid.averageFinancialAidFullTimeFirstTimeAwards)}
            </td>
            <td className="any-tot">
              {toCurrency(aid.totalFinancialAidFullTimeFirstTimeAwards)}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <p className="netprice">
        {(() => {
          const netPriceCalc = (
            <a
              target="_self"
              key="netPriceCalculator"
              href={aid.netPriceCalculator}
              className="nplink">
              {t`net price calculator`}
            </a>
          )

          return jt`To calculate how much attending this institution might cost you, you can visit the
                        ${netPriceCalc} on the insitution's website.`
        })()}
      </p>
      <p className="disclaimer">{t`Financial aid is only available to those who qualify`}</p>
    </div>
  )
}

export { FinancialAid }
